import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#1f1f1f",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M120-320v-80h320v80zm0-160v-80h480v80zm0-160v-80h480v80zm534 440L512-342l56-56 86 84 170-170 56 58z" }, null, -1)
  ]))]))
}
export default { render: render }